export class SaveButton {
  constructor(controller) {
    this.controller = controller;
  }

  initializeSaveButton() {
    if (this.controller.hasSaveButtonTarget) {
      this.controller.saveButtonTarget.addEventListener("click", this.savePage.bind(this));
    }
  }

  async savePage() {
    console.log('Функция сохранения страницы инициализирована');
    const savePageUrl = this.controller.saveButtonTarget.dataset.savePageUrl;

    // Temporarily remove all image-change-btn and section-control elements
    const imageChangeButtons = document.querySelectorAll('.image-change-btn');
    const sectionControls = document.querySelectorAll('.section-controls');
    const localCourseSection = document.getElementById('courses-local')
    const notSaveElement = [];

    // Store each button and its parent for restoration later
    imageChangeButtons.forEach(btn => {
      notSaveElement.push({
        element: btn,
        parent: btn.parentNode,
        nextSibling: btn.nextSibling
      });
      btn.remove();
    });

    if (localCourseSection) {
      notSaveElement.push({
        element: localCourseSection,
        parent: localCourseSection.parentNode,
        nextSibling: localCourseSection.nextSibling
      });
      localCourseSection.remove();
    }

    // Store each section control and its parent for restoration later
    sectionControls.forEach(control => {
      notSaveElement.push({
        element: control,
        parent: control.parentNode,
        nextSibling: control.nextSibling
      });
      control.remove();
    });

    // Get HTML content after buttons are removed
    const pageMain = document.getElementById('pageBody')?.outerHTML || '';
    const pageHead = document.getElementById('pageHead')?.outerHTML || '';
    const pageStyle = document.getElementById('pageStyle')?.outerHTML || '';
    const pageJs = document.getElementById('pageJs')?.outerHTML || '';

    // Restore the buttons and section controls
    notSaveElement.forEach(data => {
      if (data.nextSibling && data.parent.contains(data.nextSibling)) {
        data.parent.insertBefore(data.element, data.nextSibling);
      } else {
        data.parent.appendChild(data.element);
      }
    });

    try {
      const response = await fetch(savePageUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({
          page_main: pageMain,
          page_head: pageHead,
          page_style: pageStyle,
          page_js: pageJs
        })
      });

      if (response.ok) {
        this.controller.showToaster('Страница успешно сохранена');
      } else {
        const errorData = await response.json();
        console.error('Ошибка при сохранении страницы:', errorData);
        this.controller.showToaster(errorData.error || 'Не удалось сохранить страницу');
      }
    } catch (error) {
      console.error('Ошибка при сохранении страницы:', error);
      this.controller.showToaster('Ошибка при сохранении страницы');
    }
  }
}
